import store from '../store';

const physicianRoutes = [
	{ 
		path: '/physicians/map', 
		name: 'physicians.map',
		component: require('../pages/physicians/PhysicianMap.vue').default
	},
	{ 
		path: '/physicians/list', 
		name: 'physicians.list',
		component: require('../pages/physicians/PhysicianList.vue').default
	},
	{ 
		path: '/physicians/duplicates', 
		name: 'physicians.tools.duplicates',
		component: require('../pages/physicians/DuplicateFinder.vue').default
	},
	{ 
		path: '/physicians/inactive', 
		name: 'physicians.tools.inactive',
		component: require('../pages/physicians/InactiveList.vue').default
	},
	{ 
		path: '/physicians/import', 
		name: 'physicians.tools.import',
		component: require('../pages/physicians/PhysicianImport.vue').default,

		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				if (perms.can_create_physician) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},

	{ 
		path: '/physicians/smart-lists', 
		name: 'smart_lists.index',
		component: require('../pages/physicians/SmartListsIndex.vue').default
	},

	{
		path: '/physicians/smart-lists/radar',
		name: 'smart_lists.radar',
		component: require('../pages/physicians/SmartListsRadar.vue').default
	},

	{
		path: '/physicians/smart-lists/new',
		name: 'smart_lists.new',
		component: require('../pages/physicians/SmartListsNew.vue').default
	},

	{
		path: '/physicians/smart-lists/top',
		name: 'smart_lists.top',
		component: require('../pages/physicians/SmartListsTop.vue').default
	},

	{
		path: '/physicians/smart-lists/latent',
		name: 'smart_lists.latent',
		component: require('../pages/physicians/SmartListsLatent.vue').default
	},

	{
		path: '/physicians/smart-lists/new-referrers',
		name: 'smart_lists.new_referrers',
		component: require('../pages/physicians/SmartListsNewReferrers.vue').default
	},

	{ 
		path: '/physicians/:id', 
		name: 'physicians.show',
		component: require('../pages/physicians/PhysicianProfile.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},
	
];

export default physicianRoutes;